import { NgModule, ValueProvider } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DatePickerComponent } from './datepicker.component';
import { DatePickerModule } from './datepicker.module';
/**
 * NgModule definition for the DatePicker component with providers.
 */
export class DatePickerAllModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [CommonModule, DatePickerModule],
    exports: [
        DatePickerModule
    ],
    providers:[
        
    ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function DatePickerAllModule_tsickle_Closure_declarations() {
/** @type {?} */
DatePickerAllModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
DatePickerAllModule.ctorParameters;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
